import * as _ from 'underscore';
import * as $ from 'jquery';

const chartTypesList = [
    {
        id: 1,
        text: 'line',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false
    },
    {
        id: 2,
        text: 'fullstackedline',
        isXY: true,
        stacked: true,
        fullStacked: true,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 3,
        text: 'stackedline',
        isXY: true,
        stacked: true,
        fullStacked: false,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 19,
        text: 'bubble',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false,
        bubble: true
    },
    {
        id: 4,
        text: 'area',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false
    },
    {
        id: 5,
        text: 'fullstackedarea',
        isXY: true,
        stacked: true,
        fullStacked: true,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 6,
        text: 'stackedarea',
        isXY: true,
        stacked: true,
        fullStacked: false,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 7,
        text: 'bar',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 8,
        text: 'fullstackedbar',
        isXY: true,
        stacked: true,
        fullStacked: true,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 9,
        text: 'stackedbar',
        isXY: true,
        stacked: true,
        fullStacked: false,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 10,
        text: 'spline',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false
    },
    {
        id: 20,
        text: 'fullstackedspline',
        isXY: true,
        stacked: true,
        fullStacked: true,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 21,
        text: 'stackedspline',
        isXY: true,
        stacked: true,
        fullStacked: false,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 11,
        text: 'splinearea',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false
    },
    {
        id: 22,
        text: 'fullstackedsplinearea',
        isXY: true,
        stacked: true,
        fullStacked: true,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 23,
        text: 'stackedsplinearea',
        isXY: true,
        stacked: true,
        fullStacked: false,
        sideBySide: true,
        fiscal: false
    },
    {
        id: 12,
        text: 'stepline',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false
    },
    {
        id: 13,
        text: 'steparea',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false
    },
    {
        id: 14,
        text: 'scatter',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false
    },
    {
        id: 15,
        text: 'candlestick',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: true
    },
    {
        id: 16,
        text: 'stock',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: true
    },
    {
        id: 17,
        text: 'rangearea',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false,
        range: true
    },
    {
        id: 18,
        text: 'rangebar',
        isXY: true,
        stacked: false,
        fullStacked: false,
        sideBySide: false,
        fiscal: false,
        range: true
    }
    // 19 above    20 - 23
];

export class ChartTypesWrapper {
    // - XY Charts

    private bothChartTypesList: any[] | null;

    constructor() {
        this.bothChartTypesList = null;
    }

    public GetChartTypesList() {
        return chartTypesList;
    }

    public GetChartTypeDefault() {
        return 'line';
    }

    public isContinuousChartType(cType: string) {
        return (
            cType === 'line' ||
            cType === 'fullstackedline' ||
            cType === 'stackedline' ||
            cType === 'area' ||
            cType === 'fullstackedarea' ||
            cType === 'stackedarea' ||
            cType === 'spline' ||
            cType === 'fullstackedspline' ||
            cType === 'stackedspline' ||
            cType === 'splinearea' ||
            cType === 'fullstackedsplinearea' ||
            cType === 'stackedsplinearea' ||
            cType === 'stepline' ||
            cType === 'steparea'
        );
    }

    // - Pie Charts

    private pieChartTypesList = [
        {
            id: 101,
            text: 'pie',
            isXY: false,
            stacked: false,
            fullStacked: false,
            sideBySide: false,
            fiscal: false
        },
        {
            id: 102,
            text: 'doughnut',
            isXY: false,
            stacked: false,
            fullStacked: false,
            sideBySide: false,
            fiscal: false
        }
    ];

    public GetPieChartTypesList() {
        return this.pieChartTypesList;
    }

    private generateBothChartTypesList() {
        if (this.bothChartTypesList == null) {
            this.bothChartTypesList = [];

            for (let i = 0; i < chartTypesList.length; i++) {
                let copy = $.extend(true, {}, chartTypesList[i]);
                this.bothChartTypesList.push(copy);
            }
            for (let i = 0; i < this.pieChartTypesList.length; i++) {
                let copy2 = $.extend(true, {}, this.pieChartTypesList[i]);
                this.bothChartTypesList.push(copy2);
            }
        }
        return this.bothChartTypesList;
    }

    public GetBothChartTypesList() {
        return this.generateBothChartTypesList();
    }

    private getChartTypeDescr(chartType: string) {
        let ctd = null;
        let list = this.generateBothChartTypesList();

        for (let i = 0; i < list.length; i++) {
            if (list[i].text === chartType) {
                ctd = list[i];
                break;
            }
        }
        return ctd;
    }

    public isFiscal(chartType: string) {
        let fiscal = false;
        let ctd = this.getChartTypeDescr(chartType);

        if (ctd != null && ctd.fiscal != null) {
            fiscal = ctd.fiscal;
        }

        return fiscal;
    }

    public isRange(chartType: string) {
        let range = false;
        let ctd = this.getChartTypeDescr(chartType);

        if (ctd != null && ctd.range != null) {
            range = ctd.range;
        }

        return range;
    }

    public isBubble(chartType: string) {
        let bubble = false;
        let ctd = this.getChartTypeDescr(chartType);

        if (ctd != null && ctd.bubble != null) {
            bubble = ctd.bubble;
        }

        return bubble;
    }

    // - geometry

    public getIsXY(chartType: string) {
        let isXY = true;
        let ctd = this.getChartTypeDescr(chartType);

        if (ctd != null) {
            isXY = ctd.isXY;
        }

        return isXY;
    }

    public hasPie(geometry: string) {
        return geometry === 'pie' || geometry === 'both';
    }

    public hasXY(geometry: string) {
        return geometry === 'XY' || geometry === 'both';
    }
}
